import { isObject } from "../../../../../../motion-utils@12.19.0/external/motion-utils/dist/es/is-object.mjs";
function isHTMLElement(element) {
  return isObject(element) && "offsetHeight" in element;
}
export {
  isHTMLElement
};
